import { Dispatch, ThunkAction } from 'app/types/actions';
import { IGetState } from 'app/types/types';
import { hintHide } from '../../../../../hints/effects/hintHide';
import { EHintKey } from '../../../../../hints';

export const onHintHide = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(hintHide(EHintKey.ASIDE_COLUMN_TOGGLE));
    };
    return action;
};
